import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { NavigationBackLink, NavigationLink } from "navigation-react";

const TopActionMenus = ({
  // actionmenuesClass = "",
  addLabel = "",
  AddTitle = "",
  faUsersIcon,
  stateKey = "",
  navigationData = "",
  backLable = "",
  backIcon,
  distance,
  ctscanAddUserStateKey = "",
  ctscanAddUsernavigationData = "",
  ctscanAddUseraddLabel = "",
  ctscanAddUserfaUsersIcon,
  ctscanRegisteraddLabel = "",
  ctscanRegisterfaUsersIcon,
  ctscanRegisternavigationData = "",
  ctscanRegisterstateKey = "",
  onClick,
  onClickIcon,
  buttonLabel = "",
}) => {
  return (
    <div className="patient-register-header">
      <div className="patient-register-header-title">
        <NavigationBackLink
          distance={distance}
          // navigating={() => {
          //   alert("sdss");
          // }}
        >
          <FontAwesomeIcon icon={backIcon} />
          {backLable}
        </NavigationBackLink>
        <h2>{AddTitle}</h2>
      </div>
      <div className="header-button">
        <ul>
          {ctscanAddUserStateKey && (
            <li>
              <NavigationLink
                stateKey={ctscanAddUserStateKey}
                navigationData={ctscanAddUsernavigationData}
              >
                <FontAwesomeIcon icon={ctscanAddUserfaUsersIcon} />
                {ctscanAddUseraddLabel}
              </NavigationLink>
            </li>
          )}
          {stateKey && (
            <li>
              <NavigationLink
                stateKey={stateKey}
                navigationData={navigationData}
              >
                <FontAwesomeIcon icon={faUsersIcon} /> {addLabel}
              </NavigationLink>
            </li>
          )}
          {ctscanRegisterstateKey && (
            <li>
              <NavigationLink
                stateKey={ctscanRegisterstateKey}
                navigationData={ctscanRegisternavigationData}
              >
                <FontAwesomeIcon icon={ctscanRegisterfaUsersIcon} />
                {ctscanRegisteraddLabel}
              </NavigationLink>
            </li>
          )}
          {onClick && (
            <li>
              <button className="btn-action-modal" onClick={onClick}>
                <FontAwesomeIcon icon={onClickIcon} />
                {buttonLabel}
              </button>
            </li>
          )}
        </ul>
      </div>
    </div>
  );
};

export default TopActionMenus;
